const DICT_ALL_ORGANIZATION_REQUEST = "DICT_ALL_ORGANIZATION_REQUEST";
const DICT_ALL_ORGANIZATION_COMPLETE = "DICT_ALL_ORGANIZATION_COMPLETE";
const DICT_ALL_ORGANIZATION_ERROR = "DICT_ALL_ORGANIZATION_ERROR";

const DICT_ALL_REGION_REQUEST = "DICT_ALL_REGION_REQUEST";
const DICT_ALL_REGION_COMPLETE = "DICT_ALL_REGION_COMPLETE";
const DICT_ALL_REGION_ERROR = "DICT_ALL_REGION_ERROR";

const DICT_ALL_MUNICIPAL_REQUEST = "DICT_ALL_MUNICIPAL_REQUEST";
const DICT_ALL_MUNICIPAL_COMPLETE = "DICT_ALL_MUNICIPAL_COMPLETE";
const DICT_ALL_MUNICIPAL_ERROR = "DICT_ALL_MUNICIPAL_ERROR";

const DICT_ALL_WS_CATEGORY_REQUEST = "DICT_ALL_WS_CATEGORY_REQUEST";
const DICT_ALL_WS_CATEGORY_COMPLETE = "DICT_ALL_WS_CATEGORY_COMPLETE";
const DICT_ALL_WS_CATEGORY_ERROR = "DICT_ALL_WS_CATEGORY_ERROR";

const DICT_ALL_TARGET_GROUP_REQUEST = "DICT_ALL_TARGET_GROUP_REQUEST";
const DICT_ALL_TARGET_GROUP_COMPLETE = "DICT_ALL_TARGET_GROUP_COMPLETE";
const DICT_ALL_TARGET_GROUP_ERROR = "DICT_ALL_TARGET_GROUP_ERROR";

const DICT_ALL_TRIAL_FORM_REQUEST = "DICT_ALL_TRIAL_FORM_REQUEST";
const DICT_ALL_TRIAL_FORM_COMPLETE = "DICT_ALL_TRIAL_FORM_COMPLETE";
const DICT_ALL_TRIAL_FORM_ERROR = "DICT_ALL_TRIAL_FORM_ERROR";

const DICT_ALL_EDU_FORM_REQUEST = "DICT_ALL_EDU_FORM_REQUEST";
const DICT_ALL_EDU_FORM_COMPLETE = "DICT_ALL_EDU_FORM_COMPLETE";
const DICT_ALL_EDU_FORM_ERROR = "DICT_ALL_EDU_FORM_ERROR";

const DICT_ORG_LEGAL_FORM_REQUEST = "DICT_ORG_LEGAL_FORM_REQUEST";
const DICT_ORG_LEGAL_FORM_COMPLETE = "DICT_ORG_LEGAL_FORM_COMPLETE";
const DICT_ORG_LEGAL_FORM_ERROR = "DICT_ORG_LEGAL_FORM_ERROR";

const DICT_GROUP_TYPES_REQUEST = "DICT_GROUP_TYPES_REQUEST";
const DICT_GROUP_TYPES_COMPLETE = "DICT_GROUP_TYPES_COMPLETE";
const DICT_GROUP_TYPES_ERROR = "DICT_GROUP_TYPES_ERROR";

const DICT_PERSON_POST_REQUEST = "DICT_PERSON_POST_REQUEST";
const DICT_PERSON_POST_COMPLETE = "DICT_PERSON_POST_COMPLETE";
const DICT_PERSON_POST_ERROR = "DICT_PERSON_POST_ERROR";

const DICT_ALL_SKILLS_REQUEST = "DICT_ALL_SKILLS_REQUEST";
const DICT_ALL_SKILLS_COMPLETE = "DICT_ALL_SKILLS_COMPLETE";
const DICT_ALL_SKILLS_ERROR = "DICT_ALL_SKILLS_ERROR";

const DICT_ALL_MODULES_REQUEST = "DICT_ALL_MODULES_REQUEST";
const DICT_ALL_MODULES_COMPLETE = "DICT_ALL_MODULES_COMPLETE";
const DICT_ALL_MODULES_ERROR = "DICT_ALL_MODULES_ERROR";


export default {
  DICT_ALL_ORGANIZATION_REQUEST,
  DICT_ALL_ORGANIZATION_COMPLETE,
  DICT_ALL_ORGANIZATION_ERROR,

  DICT_ALL_REGION_REQUEST,
  DICT_ALL_REGION_COMPLETE,
  DICT_ALL_REGION_ERROR,

  DICT_ALL_MUNICIPAL_REQUEST,
  DICT_ALL_MUNICIPAL_COMPLETE,
  DICT_ALL_MUNICIPAL_ERROR,

  DICT_ALL_WS_CATEGORY_REQUEST,
  DICT_ALL_WS_CATEGORY_COMPLETE,
  DICT_ALL_WS_CATEGORY_ERROR,

  DICT_ALL_EDU_FORM_REQUEST,
  DICT_ALL_EDU_FORM_COMPLETE,
  DICT_ALL_EDU_FORM_ERROR,

  DICT_ORG_LEGAL_FORM_REQUEST,
  DICT_ORG_LEGAL_FORM_COMPLETE,
  DICT_ORG_LEGAL_FORM_ERROR,

  DICT_ALL_TARGET_GROUP_REQUEST,
  DICT_ALL_TARGET_GROUP_COMPLETE,
  DICT_ALL_TARGET_GROUP_ERROR,

  DICT_ALL_TRIAL_FORM_REQUEST,
  DICT_ALL_TRIAL_FORM_COMPLETE,
  DICT_ALL_TRIAL_FORM_ERROR,

  DICT_ALL_SKILLS_REQUEST,
  DICT_ALL_SKILLS_COMPLETE,
  DICT_ALL_SKILLS_ERROR,

  DICT_ALL_MODULES_REQUEST,
  DICT_ALL_MODULES_COMPLETE,
  DICT_ALL_MODULES_ERROR,

  DICT_GROUP_TYPES_REQUEST,
  DICT_GROUP_TYPES_COMPLETE,
  DICT_GROUP_TYPES_ERROR,

  DICT_PERSON_POST_REQUEST,
  DICT_PERSON_POST_COMPLETE,
  DICT_PERSON_POST_ERROR
}
